<script lang="ts" setup>
import { injectFilterComposable } from '@autobid/ui/utils/carsList/injectFilterComposable'

interface Props {
  id: string
  checked: boolean
  counter?: number
  label: string
  typeLabel: string
}

defineProps<Props>()

const useFilter = injectFilterComposable()
const {
  filters: { category },
} = useFilter()

function handleFilter(isAdding: boolean, value: string) {
  const currentValue = category.value || []

  category.value = isAdding
    ? [...currentValue, value]
    : currentValue.filter(el => el !== value)
}
</script>

<template>
  <ElementsCheckbox
    class="[&>*]:text-[#58585A]"
    :checked="checked"
    :label-suffix="counter ?? 0"
    :disabled="!counter"
    :label="label"
    :small="true"
    @change="(isAdding: boolean) => handleFilter(isAdding, id)"
  />
</template>
